import imageUrlBuilder from '@sanity/image-url';
import { Sanity$Image } from '../../types/sanityImage';
import { Sanity$FloatingImage } from '../../types/sanityTypes';
import { getSanityClientConfig } from './sanityClient';

/**
 * Generate optimized hero image URL with smart cropping and aspect ratio handling
 * Uses container dimensions and applies DPR via Sanity's .dpr() method
 */
export const generateHeroImageUrl = (
  image: Sanity$Image | Sanity$FloatingImage,
  width: number,
  height: number,
  devicePixelRatio: number = 1,
  quality: number = 95, // Higher quality for hero images
): string => {
  const urlBuilder = imageUrlBuilder(getSanityClientConfig());

  return urlBuilder
    .image(image)
    .fit('crop') // Smart crop to maintain aspect ratio and focus on important parts
    .dpr(devicePixelRatio)
    .width(width)
    .height(height)
    .quality(quality)
    .auto('format')
    .url();
};
